import { IconButton } from "@mui/material"
import { icons } from "../../../utils/icons"
import { useStyles } from "../styles"
import { ExpandIconProps } from "../types"
import { useMemo } from "react"

export const ExpandIcon = ({ value, maxCount = 0, expand, addEvidences, addDignature, handleExpanded, seeFiles, galleryAndComment, accept, name }: ExpandIconProps) => {
    const styles = useStyles()
    const list = useMemo(() => Object.values(value ?? {}) || [], [value])
    if (list?.length < maxCount) {
        return (
            <IconButton
                sx={styles.add}
                onClick={(e) => {
                    if (expand) {
                        e.stopPropagation()
                    }
                    handleExpanded(name, true)

                    seeFiles({ name, value: false })
                    if (galleryAndComment.includes(name)) {
                        addEvidences({ e, name, accept })
                    } else {
                        addDignature({ e, name, accept })
                    }
                }}
            >
                {icons('add-outline')}
            </IconButton>
        )
    }
    return <></>
}